import { type ColumnDefinition } from '@turnpike/portal-data-grid';
import { useCallback, useMemo } from 'react';

import { Details } from './components/Details';
import { DetailsRow } from './components/DetailsRow';
import { OrganizationName } from './components/OrganizationName';
import { Title } from './components/Title';
import { UserAvatar } from './components/UserAvatar';

import type { NotificationModel } from '../model/types/notification.model';
import type { Organization } from '@/features/Shared/model/types/organization.dto';
import type { UserModel } from '@/features/Shared/users/model/types/users.model';

interface Props {
	users: Record<string, UserModel> | undefined;
	organizations: Record<string, Organization> | undefined;
}

export const useTableLayoutColumns = (props: Props) => {
	const { users, organizations } = props;
	const columns = useMemo((): ColumnDefinition<NotificationModel>[] => {
		return [
			{
				key: 'title',
				title: 'Title',
				width: 220,
				draggable: false,
				render: (_value, row) => <Title item={row} />,
			},
			{
				key: 'sentById',
				title: 'Sent By',
				width: 200,
				render: (_value, row) => <UserAvatar user={users?.[row.sentById]} />,
			},
			{
				key: 'organizationId',
				title: 'Organization',
				width: 200,
				render: (_value, row) => (
					<OrganizationName organization={organizations?.[row.organizationId]} />
				),
			},
			{
				key: 'details',
				title: 'details',
				width: 160,
				render: () => <Details />,
			},
			{
				key: 'sentTo',
				title: 'Sent to',
				width: 120,
				render: () => 'N/A',
				align: 'center',
			},
			{
				key: 'readBy',
				title: 'Read by',
				width: 120,
				render: () => 'N/A',
				align: 'center',
			},
		];
	}, [users, organizations]);

	const handleDetailsRow = useCallback(
		(row: NotificationModel) => {
			return <DetailsRow notification={row} users={users} />;
		},
		[users]
	);

	return { columns, handleDetailsRow };
};
